"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOidcUrl = void 0;
const pageData_1 = require("root/src/shared/constants/pageData");
const auth_1 = require("root/src/shared/constants/auth");
// TODO rename it? it's not oidc anymore
const getOidcUrl = (provider, token, state = {}, redirectUrl = pageData_1.tokenRedirectUri) => {
    const stateJSON = JSON.stringify(Object.assign({ token, redirectUrl }, state));
    const stateEncoded = encodeURIComponent(stateJSON);
    return `${auth_1.authApiBase}/sign-in/${provider}?state=${stateEncoded}`;
};
exports.getOidcUrl = getOidcUrl;
